var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.951,
    height: 23.439,
    viewBox: "0 0 23.951 23.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand",
    transform: "translate(-6.337 -7.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_201",
    "data-name": "Grupo 201",
    transform: "translate(6.337 30.508) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M29.091,29.578H22.452q-1.791,0-3.582,0c-.408,0-.754.119-.738.59.015.45.348.594.76.583.064,0,.128,0,.192,0,3.411,0,6.823-.013,10.234.012.568,0,.716-.165.714-.725q-.027-11.257,0-22.514c0-.581-.188-.711-.732-.71q-11,.023-22,0c-.582,0-.708.193-.7.738.022,3.539.012,7.078.012,10.617v.612c.745.152.916.013.917-.731q.008-4.637,0-9.274V8.05H29.091C29.091,15.228,29.091,22.346,29.091,29.578ZM6.606,25.987c0,1.384.012,2.769-.008,4.153-.006.42.09.619.56.616,2.641-.016,5.282-.011,7.923,0,.529,0,.793-.241.793-.768q0-3.993,0-7.986c0-.534-.263-.772-.789-.771-2.641,0-5.282.008-7.923,0-.452,0-.574.181-.566.613C6.621,23.218,6.606,24.6,6.606,25.987ZM24.724,13.171l.171.076c0,1.186,0,2.373,0,3.559,0,.414.134.749.589.746s.592-.328.591-.748q-.01-2.525,0-5.05c0-.514-.244-.728-.746-.726q-2.525.011-5.049,0c-.418,0-.741.142-.733.6s.338.584.753.581c1.044-.008,2.088,0,3.132,0a5.223,5.223,0,0,1,.533.063c-.2.217-.329.36-.463.493q-3.007,3-6.014,6.006c-.295.294-.618.617-.223,1.032.426.447.765.111,1.077-.2q1.085-1.084,2.165-2.173Q22.615,15.3,24.724,13.171Z",
    transform: "translate(-6.594 -6.813)",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    d: "M29.09,29.578V8.05H7.525v.725q0,4.637,0,9.274c0,.744-.173.883-.917.731v-.612c0-3.539.011-7.079-.012-10.617,0-.545.123-.739.7-.738q11,.027,22,0c.545,0,.734.129.732.71q-.029,11.257,0,22.514c0,.56-.146.729-.714.725-3.411-.025-6.823-.012-10.234-.012-.064,0-.128,0-.192,0-.412.011-.745-.133-.76-.583-.016-.472.33-.591.738-.59q1.791,0,3.582,0H29.09Z",
    transform: "translate(-6.594 -6.813)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_133",
    "data-name": "Caminho 133",
    d: "M6.625,124.167c0-1.384.015-2.769-.009-4.153-.007-.432.114-.615.566-.613,2.641.012,5.282.008,7.923,0,.525,0,.789.237.789.771q0,3.993,0,7.986c0,.528-.264.77-.793.768-2.641-.006-5.282-.011-7.923.005-.47,0-.566-.2-.56-.616C6.637,126.936,6.625,125.551,6.625,124.167Zm8.034,3.557v-7.09H7.6v7.09Z",
    transform: "translate(-6.613 -104.992)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M96.165,41.9q-2.11,2.131-4.221,4.261-1.08,1.089-2.165,2.173c-.312.312-.651.648-1.077.2-.394-.414-.071-.737.223-1.032q3.006-3,6.014-6.006c.134-.134.26-.276.463-.493a5.259,5.259,0,0,0-.533-.063c-1.044,0-2.088-.009-3.132,0-.416,0-.745-.124-.753-.581s.315-.6.733-.6q2.525.006,5.049,0c.5,0,.748.212.746.726q-.01,2.525,0,5.05c0,.42-.143.744-.591.748s-.59-.332-.589-.746c0-1.186,0-2.373,0-3.559Z",
    transform: "translate(-78.035 -35.544)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M21.366,136.123H14.308v-7.09h7.058Z",
    transform: "translate(-13.321 -113.392)",
    fill: "none",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.5ff1efd82e7b2c4fd8a82ff0b557deb4.svg";
export { ForwardRef as ReactComponent };